import type { StatusDataRecord } from '../shared/StatusOrder.ts';

export const OrderStatusData: StatusDataRecord = {
    open: {
        color: 'warning',
        icon: 'question-sign',
        status: 'open',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.open',
    },
    planned: {
        color: 'default',
        icon: 'calendar',
        status: 'planned',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.planned',
    },
    'in-transit': {
        color: 'info',
        icon: 'tire',
        status: 'in-transit',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.underway',
    },
    loading: {
        color: 'info',
        icon: 'load ',
        status: 'loading',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.loading',
    },
    unloading: {
        color: 'info',
        icon: 'load-unload',
        status: 'unloading',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.unloading',
    },
    executing: {
        color: 'info',
        icon: 'wrench',
        status: 'executing',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.executing',
    },
    finished: {
        color: 'success',
        icon: 'ok',
        status: 'finished',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.order.status.finished',
    },
};
